(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feds-page-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-feds-page-nav]';
  const setOpen = (nav, open) => {
    nav.dataset.open = String(open);
    nav.querySelector('button').setAttribute('aria-expanded', String(open));
  };
  const initialize = () => document.querySelectorAll(selector).forEach(nav => {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    setOpen(nav, false);
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', event => {
    document.querySelectorAll(selector).forEach(nav => {
      const toggle = event.target.closest('.feds-page-nav__toggle');
      if (toggle && nav.contains(toggle)) setOpen(nav, toggle.getAttribute('aria-expanded') !== 'true');
      else if (!nav.contains(event.target) || event.target.closest('.feds-page-nav__links a')) setOpen(nav, false);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${selector}[data-open=true]`).forEach(nav => {
      const focused = nav.contains(document.activeElement);
      setOpen(nav, false);
      if (focused) nav.querySelector('button').focus();
    });
  });
  window.matchMedia('(min-width:769px)').addEventListener('change', () => {
    document.querySelectorAll(selector).forEach(nav => setOpen(nav, false));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feds-restriction"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feds-personnel-notice')) {
  customElements.define('feds-personnel-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.block = this.closest('[data-fe-restriction-block]');
      this.target = this.closest('.js-product')?.querySelector('[data-fe-restriction-target]');
      if (!this.block || !this.target) return;
      this.origin = document.createComment('');
      this.block.before(this.origin);
      this.desktop = matchMedia('(min-width: 769px)');
      this.onViewportChange = () => this.positionNotice();
      this.desktop.addEventListener('change', this.onViewportChange);
      this.initialized = true;
      this.positionNotice();
    }

    positionNotice() {
      if (this.desktop.matches) {
        if (this.block.parentElement !== this.target) this.target.append(this.block);
      } else if (this.origin.parentNode && this.origin.nextSibling !== this.block) {
        this.origin.after(this.block);
      }
    }

    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.desktop?.removeEventListener('change', this.onViewportChange);
        this.origin?.remove();
        this.initialized = false;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feds-same-day-ship"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feds-same-day-ship')) {
  customElements.define('feds-same-day-ship', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.buttonObserver?.disconnect();
      this.controller = new AbortController();
      this.productSection = this.closest('.js-product');
      this.form = document.getElementById(this.dataset.productFormId);
      this.button = this.querySelector('[data-sd-add-to-cart]');
      this.error = this.querySelector('[role="alert"]');
      this.colorIndex = Number(this.dataset.colorIndex);
      const data = JSON.parse(this.querySelector('[data-sd-variant-data]').textContent);
      this.variants = data.variants;
      this.variant = data.selected;
      this.updateVariant(this.variants.find(v => String(v.id) === this.form?.elements.id?.value) || this.variant);
      this.productSection?.addEventListener('on:variant:change', event => {
        if (event.target.closest('.js-product') !== this.productSection) return;
        this.updateVariant(event.detail?.variant);
      }, {signal:this.controller.signal});
      this.form?.addEventListener('submit', event => {
        if (event.submitter !== this.button) return;
        event.preventDefault();
        event.stopPropagation();
        Promise.resolve().then(() => this.addToCart());
      }, {signal:this.controller.signal});
      if (this.form) {
        this.buttonObserver = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[name="add"], .gpo-clone-atc-button') || node.querySelector('[name="add"], .gpo-clone-atc-button'))))) this.syncStandardButtons();
        });
        this.buttonObserver.observe(this.form, {childList:true, subtree:true});
      }
    }
    updateVariant(variant) {
      this.variant = variant;
      const color = this.colorIndex >= 0 && variant ? String(variant.options?.[this.colorIndex] || '').trim().toLowerCase() : '';
      this.hidden = !['navy blue','navy','black'].includes(color);
      this.button.disabled = this.busy || this.hidden || !variant?.available || this.dataset.feeAvailable !== 'true';
      this.syncStandardButtons();
    }
    syncStandardButtons(restore = false) {
      const expeditedAvailable = !restore && !this.hidden && this.variant?.available && this.dataset.feeAvailable === 'true';
      this.form?.querySelectorAll('[name="add"], .gpo-clone-atc-button').forEach(button => {
        const originalText = button.dataset.defaultAddToCartText || button.dataset.addToCartText;
        if (!originalText) return;
        button.dataset.defaultAddToCartText = originalText;
        const text = expeditedAvailable ? this.dataset.standardButtonText : originalText;
        button.dataset.addToCartText = text;
        const label = this.variant?.available ? text : (this.variant ? theme.strings.noStock : theme.strings.noVariant);
        if (button.textContent.trim() !== label) button.textContent = label;
      });
    }
    async addToCart() {
      if (this.busy || this.hidden || this.button.disabled || !this.form?.reportValidity()) return;
      const formData = new FormData(this.form);
      const id = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);
      const feeId = Number(this.dataset.feeVariantId);
      if (!Number.isSafeInteger(quantity) || quantity < 1 || !feeId || String(id) !== String(this.variant?.id)) return;
      this.busy = true;
      this.updateVariant(this.variant);
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy','true');
      this.error.hidden = true;
      const standardButton = this.form.querySelector('[name="add"]');
      const standardDisabled = standardButton?.disabled;
      if (standardButton) standardButton.disabled = true;
      const group = crypto.randomUUID();
      let committed = false;
      try {
        const properties = {};
        for (const [key,value] of formData.entries()) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
          if (match && typeof value !== 'string' && value.size) throw new Error(this.dataset.errorMessage);
        }
        properties._sd_group = group;
        properties._sd_role = 'garment';
        const garment = {id, quantity, properties};
        if (formData.get('selling_plan')) garment.selling_plan = formData.get('selling_plan');
        const fee = {id:feeId, quantity, properties:{_sd_group:group,_sd_role:'service'}};
        // Shopify nested lines cannot be children of a bundle expanded by Globo.
        // The cart's shared group still keeps their quantities and removal together.
        if (!properties._gpo_options && !properties._gpo_addon_products) fee.parent_id = id;
        const drawer = document.querySelector('cart-drawer');
        const sections = ['cart-icon-bubble'];
        const drawerSection = drawer?.closest('.shopify-section')?.id.replace('shopify-section-','');
        if (drawerSection) sections.push(drawerSection);
        const response = await fetch(theme.routes.cartAdd, {
          method:'POST',
          headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items:[garment,fee],sections,sections_url:window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorMessage);
        const cartResponse = await fetch(`${theme.routes.cart}.js`,{headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(this.dataset.errorMessage);
        const cart = await cartResponse.json();
        const added = cart.items.filter(item => item.properties?._sd_group === group);
        if (!added.some(item => item.properties._sd_role === 'garment' && item.quantity === quantity) || !added.some(item => item.variant_id === feeId && item.quantity === quantity)) throw new Error(this.dataset.errorMessage);
        committed = true;
        this.dispatchEvent(new CustomEvent('on:cart:add',{bubbles:true,detail:{cart,variantId:id,sameDayShip:true,quantity}}));
        if (theme.settings.afterAtc === 'drawer' && drawer && drawerSection && result.sections?.[drawerSection]) {
          await drawer.renderContents(result,true);
        } else {
          window.location.assign(theme.routes.cart);
        }
      } catch (error) {
        if (!committed) {
          try {
            const check = await fetch(`${theme.routes.cart}.js`,{headers:{Accept:'application/json'}});
            if (!check.ok) throw new Error();
            const cart = await check.json();
            const added = cart.items.filter(item => item.properties?._sd_group === group);
            if (added.some(item => item.variant_id === id && item.quantity === quantity) && added.some(item => item.variant_id === feeId && item.quantity === quantity)) {
              committed = true;
            } else if (added.length) {
              const rollback = await fetch(`${theme.routes.cart}/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:Object.fromEntries(added.map(item => [item.key,0]))})});
              if (!rollback.ok) throw new Error();
            }
          } catch {
            window.location.assign(theme.routes.cart);
            return;
          }
        }
        if (committed) {
          window.location.assign(theme.routes.cart);
        } else {
          this.error.textContent = error.message || this.dataset.errorMessage;
          this.error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-busy');
        this.updateVariant(this.variant);
        if (standardButton) standardButton.disabled = standardDisabled || !this.variant?.available;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.buttonObserver?.disconnect();
      this.syncStandardButtons(true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
